import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Container, Loader, Dimmer } from 'semantic-ui-react';
import { Line } from '@ant-design/charts';
import { GetMonthIncomeReport } from '../../../api/services/finance';
import { onError, onWarning} from '../../../components/shared/messages';
import moment from 'moment'
import { useTextResources } from '../../../language';
import { Currencies } from '../../../components/shared/currencies'

export const MonthIncomeReportWidget = ({ HotelIds }) => {
	const [reportData, setReportData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const text = useTextResources();
    const currencyId = window.optima?.user?.CurrentHotel?.MainCurrencyId || 2;
	const currencySymbol = Currencies[currencyId ? currencyId : 1].symbol;

	useEffect( () => {
		if (!HotelIds.length) return;

		(async () => {
			try {
				setIsLoading(true)
				let today = moment()
				let currentYear = today.get('year')
				let startDate = moment({ year :currentYear-2, month :0, day :1}).startOf('day')
				const data = await GetMonthIncomeReport(HotelIds.reduce((spec, val, idx) => {
					spec[`SelectedHotelIDs[${idx}]`] = val
					return spec
				}, {
					StartDate: startDate.toISOString(),
					EndDate: today.endOf("day").toISOString()
				}))
				setReportData(data)
				} catch (error){
					error.status === 400 ? onWarning(error) : onError(error)
				} finally {
					setIsLoading(false)
				}
			})()
		},[HotelIds])

	const lineChartConfig = useMemo(() => {
		return {
			data: reportData,
			xField: 'Month',
			yField: 'TotalIncome',
			seriesField: 'Year',
			color: ['#1979C9', '#D62A0D', '#FAA219'],
			point: {
				size: 5,
				shape: 'circle',
			},
			yAxis: {
				title:{
					text: `${text("TotalIncome")} (${currencySymbol})`,
					autoRotate: true,
				},
				label: {
					formatter: function formatter(value) {
						const num = Number(value);
						let formatedValue;
						if(num > 999 && num < 1000000){
							formatedValue = (num/1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million 
						}else if(num > 1000000){
							formatedValue = (num/1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million 
						}else if(num < 900){
							formatedValue =  num; 
						}
						return `${formatedValue}` ;
					},
				},
			},
			xAxis: {
				title: {
					text: text("Month"),
					autoRotate: true
				},
			},
			legend: {
				position: 'bottom-right'
			},
			tooltip: {
				formatter: function formatter(item) {
					return { name: item.Year, value: `<div><b> ${item.TotalIncome.toFixed(2)} ${currencySymbol}</b></div>` };
				},
			}
	
		}
	},[reportData]);

	return (
		<>
			{isLoading ? (
				<Dimmer active inverted>
					<Loader inline='centered' size='medium' />
				</Dimmer>
			) : (
				<Container>
					<Line {...lineChartConfig} />
				</Container>
			)}
		</>
	);
};

MonthIncomeReportWidget.propTypes = {
	HotelIds: PropTypes.array,
};
